/**
 * Settings action creators
 * @format
 */
import * as types from './actions';
import reducers from './reducers';
import request from '../../helpers/request';
import isEmptyString from '../../helpers/string/isEmptyString';
import { enqueueNotification } from '../app';
import {
  setCache,
  getCache,
  getPortcoSettingCacheKey,
} from '../../helpers/Cache';

export default reducers;
/*
 * Get Portfolio setting value by key
 * @param {UUID} company_id Id of the company
 * @param {String} key Key for setting to fetch
 */
export const getPortcoSettingValueByKey = (
  company_id,
  key,
  queryOpts = {},
  options = {}
) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      // Resolve without any data, without making any api request if key is empty
      if (isEmptyString(key) || isEmptyString(company_id)) {
        return resolve();
      }
      dispatch({
        type: types.LOAD_PORTCO_SETTING_VALUE_BY_KEY_REQUEST,
        payload: {
          key,
          company_id,
        },
      });
      let cacheKey = getPortcoSettingCacheKey(key, company_id);
      if (options.useCache) {
        const cachedValue = getCache(cacheKey);
        if (cachedValue !== null) {
          dispatch({
            type: types.LOAD_PORTCO_SETTING_VALUE_BY_KEY_SUCCESS,
            payload: {
              key,
              company_id,
              value: cachedValue,
            },
          });
          return resolve({ success: true, data: cachedValue });
        }
      }
      request
        .get(
          `/api/portfolio/v1/companies/${company_id}/settings`,
          { key, ...queryOpts },
          dispatch
        )
        .then(({ data }) => {
          if (data.success) {
            dispatch({
              type: types.LOAD_PORTCO_SETTING_VALUE_BY_KEY_SUCCESS,
              payload: {
                key,
                company_id,
                value: data.data,
              },
            });
            setCache(cacheKey, data.data, { expires_on: options.expires_on });
            return resolve(data);
          } else {
            dispatch({
              type: types.LOAD_PORTCO_SETTING_VALUE_BY_KEY_FAILURE,
              payload: {
                key,
                company_id,
                message: data.message,
              },
            });
            dispatch(enqueueNotification(data.message));
            return reject(new Error(data.message));
          }
        })
        .catch(err => {
          const message =
            'Something went wrong while loading portfolio settings, please try again.';
          dispatch({
            type: types.LOAD_PORTCO_SETTING_VALUE_BY_KEY_FAILURE,
            payload: {
              key,
              company_id,
              message,
            },
          });
          dispatch(enqueueNotification(message));
          reject(err);
        });
    });
  };
};

/*
 * Updates Portfolio setting value by key
 * @param {UUID} company_id Id of the company
 * @param {String} key Key for setting to update
 * @param {Any} value Value to update
 */
export const updatePortcoSettingValueByKey = (company_id, key, value) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      // Resolve without any data, without making any api request if key is empty
      if (isEmptyString(key) || isEmptyString(company_id)) {
        return resolve();
      }
      dispatch({
        type: types.UPDATE_PORTCO_SETTING_BY_KEY_REQUEST,
        payload: {
          key,
        },
      });
      request
        .put(
          `/api/portfolio/v1/companies/${company_id}/settings`,
          { key, value },
          dispatch
        )
        .then(({ data }) => {
          if (data.success) {
            dispatch({
              type: types.UPDATE_PORTCO_SETTING_BY_KEY_SUCCESS,
              payload: {
                key,
                company_id,
                value: data.data,
              },
            });
            return resolve(data);
          } else {
            dispatch({
              type: types.UPDATE_PORTCO_SETTING_BY_KEY_FAILURE,
              payload: {
                key,
                company_id,
                message: data.message,
              },
            });
            dispatch(enqueueNotification(data.message));
            return reject(new Error(data.message));
          }
        })
        .catch(err => {
          const message =
            'Something went wrong while updating settings, please try again.';
          dispatch({
            type: types.UPDATE_PORTCO_SETTING_BY_KEY_FAILURE,
            payload: {
              key,
              company_id,
              message,
            },
          });
          dispatch(enqueueNotification(message));
          reject(err);
        });
    });
  };
};
